import React, { Component, createRef } from "react";
import { withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import Tooltip from "@material-ui/core/Tooltip";
import SnackBar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";

import EditIcon from "@material-ui/icons/Edit";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CancelIcon from "@material-ui/icons/Cancel";
import DeleteIcon from "@material-ui/icons/Delete";

import { useStyles } from "../../../../Components/CSS/FormStyle.css";
import CustomDialogBox from "../../../../Components/CustomDialogBox/CustomDialogBox";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import Axios from "axios";
import { url } from "../../../../Config/Config";
import { getAdminRefreshToken } from "../../../../Redux/Actions/actions";
import FormLoader from "../../../../Components/FormLoader/FormLoader";

class GradeBody extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dialogOpen: false,
      notificationOpen: false,
      gradeId: "",
      editStatus: false,
      reference: {
        percentFromRef: createRef(),
        percentToRef: createRef(),
        gradeRef: createRef(),
      },
      data: {
        name: "",
        percentFrom: 0,
        percentTo: 0,
        gradeNumber: 0,
      },
      error: {
        gradeNameError: "",
        percentFromError: "",
        percentToError: "",
        gradeNumberError: "",
      },
      loading: false,
    };
  }

  handleChange = (e) => {
    this.setState({
      data: {
        ...this.state.data,
        [e.target.name]: e.target.value,
      },
    });
  };

  handleWheel = (refValue) => {
    refValue.current.blur();
    setTimeout(() => refValue.current.focus(), 100);
  };

  handleDialogOpen = (gradeId) => {
    this.setState({
      dialogOpen: true,
      gradeId,
    });
  };

  handleDialogClose = () => {
    this.setState({
      dialogOpen: false,
    });
  };

  handleNotificationOpen = () => {
    this.setState({
      notificationOpen: true,
    });
  };

  handleNotificationClose = () => {
    this.setState({
      notificationOpen: false,
    });
  };

  showNotification = () => {
    return (
      <SnackBar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={this.state.notificationOpen}
        onClose={this.handleNotificationClose}
        autoHideDuration={1600}
        style={{ top: 80, right: 10 }}
      >
        <MuiAlert
          onClose={this.handleNotificationClose}
          severity="error"
          elevation={6}
          variant="filled"
        >
          Deleted Successfully
        </MuiAlert>
      </SnackBar>
    );
  };

  handleEditGrade = async (gradeId) => {
    this.setState({
      editStatus: true,
    });
    try {
      const response = await Axios.get(`${url}/api/grades/${gradeId}`, {
        headers: {
          Authorization: `Bearer ${this.props.adminToken}`,
        },
      });
      if (response.data.grade.length !== 0) {
        this.setState({
          gradeId,
          data: {
            name: response.data.grade.name,
            percentFrom: response.data.grade.percentFrom,
            percentTo: response.data.grade.percentTo,
            gradeNumber: response.data.grade.gradeNumber,
          },
        });
      }
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.handleEditGrade(gradeId);
      }
    }
  };

  handleCancelEdit = () => {
    this.setState({
      editStatus: false,
    });
  };

  handleDeleteGrades = async () => {
    try {
      const response = await Axios.delete(
        `${url}/api/grades/${this.state.gradeId}`,
        {
          headers: {
            Authorization: `Bearer ${this.props.adminToken}`,
          },
        }
      );
      if (response.data.message === "Grade deleted successfully") {
        this.handleDialogClose();
        this.handleNotificationOpen();
        this.props.getGrades();
      }
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.handleDeleteGrades();
      }
    }
  };

  checkError = (gradeName) => {
    let gradeNameError = gradeName ? gradeName : "";
    let percentFromError = "";
    let percentToError = "";
    let gradeNumberError = "";

    if (this.state.data.percentFrom < 0) {
      percentFromError = "The value must not be less than or equals to zero";
    }

    if (this.state.data.percentTo < 0) {
      percentToError = "The value must not be less than or equals to zero";
    }

    if (this.state.data.gradeNumber < 0) {
      gradeNumberError = "The value must not be less than or equals to zero";
    }

    if (
      gradeNameError ||
      percentFromError ||
      percentToError ||
      gradeNumberError
    ) {
      this.setState({
        error: {
          gradeNameError,
          percentFromError,
          percentToError,
          gradeNumberError,
        },
      });
      return true;
    } else {
      this.setState({
        error: {
          gradeNameError: "",
          percentFromError: "",
          percentToError: "",
          gradeNumberError: "",
        },
      });
      return false;
    }
  };

  handleEditSubmit = async (e) => {
    e.preventDefault();
    let errorStatus = this.checkError();
    if (errorStatus === false) {
      try {
        this.setState({ loading: true });
        const response = await Axios.put(
          `${url}/api/grades/${this.state.gradeId}`,
          this.state.data,
          {
            headers: {
              Authorization: `Bearer ${this.props.adminToken}`,
            },
          }
        );
        if (response.data.message === "Grade updated successfully") {
          this.handleCancelEdit();
          this.props.getGrades();
        }
      } catch (error) {
        this.setState({ loading: false });
        if (
          error.response.data.message === "Grade with given name already exists"
        ) {
          console.clear();
          this.checkError(error.response.data.message);
        }
        if (
          error.response.data === "jwt expired" &&
          error.response.status === 401
        ) {
          console.clear();
          let refreshToken = { refreshToken: this.props.refreshToken };
          this.props.getAdminRefreshToken(refreshToken, this.props.role);
          this.handleEditSubmit(e);
        }
      }
    }
  };

  render() {
    const { classes, data, index } = this.props;
    return this.state.editStatus === false ? (
      <TableRow
        style={{
          backgroundColor: `${index % 2 ? "#fff" : "#eee"}`,
        }}
      >
        <TableCell align="center">{index + 1}</TableCell>
        <TableCell align="center">{data.name}</TableCell>
        <TableCell align="center">{data.percentFrom}</TableCell>
        <TableCell align="center">{data.percentTo}</TableCell>
        <TableCell align="center">{data.gradeNumber}</TableCell>
        <TableCell align="center">
          <Tooltip
            title="Edit"
            arrow
            className={classes.tooltip}
            onClick={() => this.handleEditGrade(data._id)}
          >
            <EditIcon />
          </Tooltip>
          <Tooltip
            title="Delete"
            arrow
            className={classes.tooltip}
            onClick={() => this.handleDialogOpen(data._id)}
          >
            <DeleteIcon />
          </Tooltip>
          {this.showNotification()}
        </TableCell>
        <CustomDialogBox
          open={this.state.dialogOpen}
          handleClose={this.handleDialogClose}
          handleDelete={this.handleDeleteGrades}
        />
      </TableRow>
    ) : (
      <TableRow>
        <TableCell />
        <TableCell align="center">
          <TextField
            name="name"
            type="text"
            label="Grade Name"
            required
            fullWidth
            variant="outlined"
            margin="normal"
            placeholder="Enter the name of grade"
            error={this.state.error.gradeNameError ? true : false}
            helperText={this.state.error.gradeNameError}
            InputProps={{
              classes: {
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
            }}
            InputLabelProps={{
              classes: {
                root: classes.labelRoot,
                focused: classes.labelFocused,
              },
              shrink: true,
            }}
            value={this.state.data.name}
            onChange={this.handleChange}
          />
        </TableCell>
        <TableCell align="center">
          <TextField
            name="percentFrom"
            type="number"
            label="Percentage From"
            required
            fullWidth
            variant="outlined"
            margin="normal"
            error={this.state.error.percentFromError ? true : false}
            helperText={this.state.error.percentFromError}
            placeholder="Enter starting percentage"
            InputProps={{
              classes: {
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
              inputProps: { min: 0, max: 100 },
            }}
            InputLabelProps={{
              classes: {
                root: classes.labelRoot,
                focused: classes.labelFocused,
              },
              shrink: true,
            }}
            inputRef={this.state.reference.percentFromRef}
            onWheel={() =>
              this.handleWheel(this.state.reference.percentFromRef)
            }
            value={this.state.data.percentFrom}
            onChange={this.handleChange}
          />
        </TableCell>
        <TableCell align="center">
          <TextField
            name="percentTo"
            type="number"
            label="Percentage To"
            required
            fullWidth
            variant="outlined"
            margin="normal"
            error={this.state.error.percentToError ? true : false}
            helperText={this.state.error.percentToError}
            placeholder="Enter ending percentage"
            InputProps={{
              classes: {
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
              inputProps: { min: 0, max: 100 },
            }}
            InputLabelProps={{
              classes: {
                root: classes.labelRoot,
                focused: classes.labelFocused,
              },
              shrink: true,
            }}
            inputRef={this.state.reference.percentToRef}
            onWheel={() => this.handleWheel(this.state.reference.percentToRef)}
            value={this.state.data.percentTo}
            onChange={this.handleChange}
          />
        </TableCell>
        <TableCell align="center">
          <TextField
            name="gradeNumber"
            type="number"
            label="Grade"
            required
            fullWidth
            variant="outlined"
            margin="normal"
            error={this.state.error.gradeNumberError ? true : false}
            helperText={this.state.error.gradeNumberError}
            placeholder="Enter grade"
            InputProps={{
              classes: {
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
            }}
            InputLabelProps={{
              classes: {
                root: classes.labelRoot,
                focused: classes.labelFocused,
              },
              shrink: true,
            }}
            inputRef={this.state.reference.gradeRef}
            onWheel={() => this.handleWheel(this.state.reference.gradeRef)}
            value={this.state.data.gradeNumber}
            onChange={this.handleChange}
          />
        </TableCell>
        <TableCell align="center">
          <Tooltip
            title="Update"
            arrow
            onClick={this.handleEditSubmit}
            className={classes.tooltip}
          >
            <CheckCircleIcon />
          </Tooltip>
          <Tooltip
            title="Cancel"
            arrow
            onClick={this.handleCancelEdit}
            className={classes.tooltip}
          >
            <CancelIcon />
          </Tooltip>
          {this.state.loading && <FormLoader />}
        </TableCell>
      </TableRow>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
    refreshToken: state.AdminReducer.refreshToken,
    role: state.AdminReducer.role,
    isAdmin: state.AdminReducer.isAdmin,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAdminRefreshToken: (refreshToken, role) => {
      dispatch(getAdminRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(withRouter(GradeBody)));
